import React, { useState } from 'react';

import { List, Datagrid, TextField, DeleteButton, Edit, TextInput, Button, TopToolbar, FormTab, TabbedForm, FormDataConsumer, required, BooleanInput, FunctionField, ResourceContextProvider, useCreate, useRefresh, FormWithRedirect, Toolbar, SaveButton, useNotify, useRedirect, BooleanField } from 'react-admin';import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { makeStyles } from '@material-ui/core/styles';

import { useTranslate  } from '../common/language';

import Typography from '@mui/material/Typography';


import { TextFieldShow } from '../components/TextFieldShow';

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import MobileFriendlyIcon from '@material-ui/icons/MobileFriendly';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { targetsEmails } from './../common/constants';  

import { RenderBoolean } from '../components/User';
import { SendEmailIconStatus } from '../components/Emails';

import { Link } from 'react-router-dom';

import { validateMaxLength, validateEmail } from './../components/Validator';export const EventsSessionsValidatorsList = (props) => {
  const translate = useTranslate();  
    
  let basePath='/events_sessions_validators'; 
  let resource = 'events_sessions_validators';
    
  return (
    <ResourceContextProvider value={resource}>
      <List 
        basePath={basePath}   
        filter={{ events_sessions_id : props.events_sessions_id }}  
        actions={props.show ?  <span/> : <ListActions events_sessions_id={props.events_sessions_id} />}    
        empty={props.show ?  <span/> : <ListActions events_sessions_id={props.events_sessions_id} />}        
        bulkActionButtons={false}          
        perPage={1000}   
        pagination={false}
        sort={{ field: 'id', order: 'ASC' }} 
        label=""  
        title=""  
        resource={resource}
      >        
        <Datagrid 
          rowClick={props.show ? null : 'edit'}
          expand={<EventsSessionsValidatorsDetails />} >  
          <Avatar><MobileFriendlyIcon/></Avatar>                                  
          <TextField source="name" label={translate('tickets_validators.name')} sortable={false} />  
          <TextField source="email" label={translate('tickets_validators.email')} sortable={false} />            
          <BooleanField source="active" label={translate('events_sessions_validators.active')} sortable={false} /> 
          <FunctionField label={translate('events_sessions_validators.send_link')} render={record => 
            <SendEmailIconStatus record={record} target={targetsEmails.TICKETS_NEW_VALIDATOR}  />
        } sortable={false}  />
        </Datagrid>        
      </List>
    </ResourceContextProvider>
  );
};


export const EventsSessionsValidatorsDetails = ({ id, record, resource, ...props }) => {
  const translate = useTranslate(); 
        
  return (
    <div className="usersClassroomsExpand">        
      <Grid container spacing={2}>
        <Grid item xs={4}>   
          <TextFieldShow source={record.name} label={translate('tickets_validators.name')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.email} label={translate('tickets_validators.email')} />
        </Grid>         
        <Grid item xs={4}>   
          <TextFieldShow source={<RenderBoolean source={record.active} />} label={translate('events_sessions_validators.active')} />
        </Grid> 
        <Grid item xs={4}>   
            <TextFieldShow source={<RenderBoolean source={record.permission_validate} />} label={translate('tickets_validators.permission_validate')} />                    
        </Grid>                 
        <Grid item xs={4}>   
            <TextFieldShow source={<RenderBoolean source={record.permission_unvalidate} />} label={translate('tickets_validators.permission_unvalidate')} />                    
        </Grid> 
        <Grid item xs={4}>   
            <TextFieldShow source={<RenderBoolean source={record.permission_booking_data} />} label={translate('tickets_validators.permission_booking_data')} />                    
        </Grid> 
        <Grid item xs={4}>   
            <TextFieldShow source={<RenderBoolean source={record.permission_custom_fields} />} label={translate('tickets_validators.permission_custom_fields')} />
        </Grid> 
        <Grid item xs={4}>   
            <TextFieldShow source={<RenderBoolean source={record.permission_statistics} />} label={translate('tickets_validators.permission_statistics')} />
        </Grid>
        <Grid item xs={12}>   
          <TextFieldShow source={record.link} label={translate('events_sessions_validators.link')} />
        </Grid> 
      </Grid>
      
    </div>
  );
};

const ListActions = (props) => {
    const translate = useTranslate(); 
        
    return (
    <TopToolbar>     
        <MyCreateButton {...props} />    
    </TopToolbar>
    );
};

export const MyCreateButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('events_sessions_validators');
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  
  const redirect = useRedirect();
        
  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {                   

          redirect('/events_sessions/' + props.events_sessions_id + '/validators');
          setShowDialog(false);
          refresh();

        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };
    
  return (
    <>            
      <Button onClick={handleClick} label={translate('events_sessions_validators.create')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('events_sessions_validators.create')}
      >
        <DialogTitle>{translate('events_sessions_validators.create')}</DialogTitle>

        <FormWithRedirect
          save={handleSubmit}
          initialValues={{ events_sessions_id: props.events_sessions_id, active: true, permission_validate: true, permission_unvalidate: true, permission_booking_data: true, permission_custom_fields: true, permission_statistics: true }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>
                <Grid container spacing={1}>  
                  <Grid item xs={12}>   
                    <TextInput fullWidth source="name" label={translate('tickets_validators.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={12}>   
                    <TextInput fullWidth source="email" label={translate('tickets_validators.email')} validate={[required(),validateEmail(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={12}>   
                    <BooleanInput fullWidth source="active" label={translate('events_sessions_validators.active')}  />
                  </Grid> 
                <Grid item xs={12}>   
                    <BooleanInput fullWidth source="permission_validate" label={translate('tickets_validators.permission_validate')} />
                </Grid> 
                <Grid item xs={12}>   
                    <BooleanInput fullWidth source="permission_unvalidate" label={translate('tickets_validators.permission_unvalidate')} />
                </Grid> 
                <Grid item xs={12}>   
                    <BooleanInput fullWidth source="permission_booking_data" label={translate('tickets_validators.permission_booking_data')} />
                </Grid> 
                <Grid item xs={12}>   
                    <BooleanInput fullWidth source="permission_custom_fields" label={translate('tickets_validators.permission_custom_fields')} />
                </Grid> 
                <Grid item xs={12}>   
                    <BooleanInput fullWidth source="permission_statistics" label={translate('tickets_validators.permission_statistics')} />
                </Grid>
                <Grid item xs={12}>   
                    <BooleanInput fullWidth source="send_link_now" label={translate('events_sessions_validators.send_link')}  />
                </Grid>     
                </Grid> 
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const MyActions = ({ basePath, data, resource }) => {

  const translate = useTranslate();   
    
    let linkBack = '';
  if (data && data.events_sessions_id)
      linkBack = '/events_sessions/' + data.events_sessions_id + '/validators';
        
  return (
    <>
      <TopToolbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>   
            <div style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}>
              <Link
                to={linkBack}
                className=""
              >
                <ArrowBackIosNewIcon className="mr-2" />                        
              </Link>
              <Typography variant="h5" className="grey8">
                {data && data.name ? data.name : null}                    
              </Typography>
            </div>  
                
          </Grid>
        </Grid> 
      </TopToolbar>
    </>
  );
};


export const EventsSessionsValidatorsEdit  = ({ id, ...props }) => {

  const translate = useTranslate();        
  const classes = useStyles();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = ({ data }) => {
    notify(translate('common.notification.updated'));        
    redirect('/events_sessions/' + data.events_sessions_id + '/validators');        
  };
        
  return (

    <Edit 
      title={<ElementTitle {...props}  />} 
      {...props} 
      id={id}
      mutationMode="pessimistic"
      actions={<MyActions {...props} />}
      onSuccess={onSuccess}   
    >
        
      <TabbedForm        
        toolbar={<FormToolbar />}
      >    
        <FormTab
          label={translate('classrooms.data')}
          contentClassName={classes.tab}
          path="" 
                
        > 
               
          <FormDataConsumer>
            {({ formData, ...rest }) => 
              <>                              
                <br/>
                <Grid container spacing={2}>
                <Grid item xs={4}>   
                    <TextInput fullWidth source="name" label={translate('tickets_validators.name')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                </Grid> 
                <Grid item xs={4}>   
                    <TextInput fullWidth source="email" label={translate('tickets_validators.email')} validate={[validateEmail(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
                </Grid> 
                <Grid item xs={4}>   
                    <BooleanInput fullWidth source="active" label={translate('events_sessions_validators.active')}  />
                </Grid> 
                <Grid item xs={6}>   
                    <BooleanInput fullWidth source="permission_validate" label={translate('tickets_validators.permission_validate')} />
                </Grid> 
                <Grid item xs={6}>   
                    <BooleanInput fullWidth source="permission_unvalidate" label={translate('tickets_validators.permission_unvalidate')} />
                </Grid> 
                <Grid item xs={6}>   
                    <BooleanInput fullWidth source="permission_booking_data" label={translate('tickets_validators.permission_booking_data')} />
                </Grid> 
                <Grid item xs={6}>   
                    <BooleanInput fullWidth source="permission_custom_fields" label={translate('tickets_validators.permission_custom_fields')} />
                </Grid> 
                <Grid item xs={6}>   
                    <BooleanInput fullWidth source="permission_statistics" label={translate('tickets_validators.permission_statistics')} />
                </Grid> 
                </Grid>                                
              </>
            }
          </FormDataConsumer>

        </FormTab> 
        
    
      </TabbedForm>
    </Edit>
  );
};

const ElementTitle = ({ record, ...props }) => {    
  const translate = useTranslate(); 
  return (<span>{translate('common.edit')} {record ? `"${record.name}"` : ''}</span>);
};

const FormToolbar = ({ ...props }) => {
    
  let redirect = '/events_sessions/' + props.record.events_sessions_id + '/validators';  
    
  return (
    <Toolbar {...props} className="user_form_toolbar" >
      <SaveButton />
      <DeleteButton redirect={redirect} mutationMode="pessimistic" />
    </Toolbar>
  );
};

const useStyles = makeStyles({
  comment: {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tab: {
    maxWidth: '100%',
    display: 'block',
  },
});


